import request from '../requests/request'
import { setRecoil } from 'recoil-nexus'
import {
  districtState,
  pageConfigState,
  pageStatusListState,
  provinceState,
  wardsState,
} from '../recoil/landingPageState'
import config from '../config'

const landingPageStore = {
  getProvince: () => {
    return new Promise((resolve, reject) => {
      const url = '/api/public/province'
      request.get({
        url,
        baseUrl: config.generalInfo,
        params: null,
        disabledLoading: false,
        disableAutoError: true,
      })
        .then(res => {
          if (res) {
            setRecoil(provinceState, res?.data)
          }
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDistrict: (provinceId) => {
    return new Promise((resolve, reject) => {
      const url = `/api/public/district`
      request.get({
        url,
        baseUrl: config.generalInfo,
        params: { provinceId: provinceId },
        disabledLoading: false,
        disableAutoError: true,
      })
        .then(res => {
          if (res) {
            setRecoil(districtState, res?.data)
          }
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getWard: (districtId) => {
    return new Promise((resolve, reject) => {
      const url = `/api/public/ward`
      request.get({
        url,
        baseUrl: config.generalInfo,
        params: { districtId: districtId },
        disabledLoading: false,
        disableAutoError: true,
      })
        .then(res => {
          if (res) {
            setRecoil(wardsState, res?.data)
          }
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  registerProduct: (data) => {
    return new Promise((resolve, reject) => {
      const url = `/station/register-info`
      request.post({
        url,
        baseUrl: config.apiUrl,
        data: data,
        disabledLoading: false,
        disableAutoError: false,
      })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPageConfig: (params) => {
    return new Promise((resolve, reject) => {
      const url = `/station/view-config`
      request.get({
        url,
        baseUrl: config.apiUrl,
        params: params,
        disabledLoading: false,
        disableAutoError: false,
      })
        .then(res => {
          setRecoil(pageConfigState, res?.data)
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPageStatus: (params) => {
    return new Promise((resolve, reject) => {
      const url = `/landingpage/list`
      request.get({
        url,
        baseUrl: config.apiUrl,
        params: params,
        disabledLoading: false,
        disableAutoError: false,
      })
        .then(res => {
          setRecoil(pageStatusListState, res?.data)
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
export default landingPageStore